var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncreaseQ(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0641095 7.768V5.5H11.9361V7.768H0.0641095ZM4.85211 0.403999H7.17611V12.864H4.85211V0.403999Z",
    fill: "#650D1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreaseQ);
export default __webpack_public_path__ + "static/media/increaseQ.29e949c0a09c0d05f86731774bae6d12.svg";
export { ForwardRef as ReactComponent };